import { useEffect, useState } from "react";
import { adSetPerformance } from "../lib/api";
import { PERFORMANCE_POLL_INTERVAL_MS } from "../lib/constants";

/**
 * Poll /api/ad-sets/{id}/performance every N ms.
 * Returns the current performance[] array. Empty array when no ad set.
 */
export default function useAdSetPerformance(adSetId) {
  const [performance, setPerformance] = useState([]);

  useEffect(() => {
    if (!adSetId) {
      setPerformance([]);
      return undefined;
    }
    let cancelled = false;

    const fetchPerf = async () => {
      try {
        const p = await adSetPerformance(adSetId);
        if (!cancelled) setPerformance(p.performance || []);
      } catch (err) {
        console.warn("adSetPerformance poll failed:", err?.message || err);
      }
    };

    fetchPerf();
    const timer = setInterval(fetchPerf, PERFORMANCE_POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [adSetId]);

  return [performance, setPerformance];
}
